import React, { useState } from 'react'
import { CCol, CRow } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilChevronBottom, cilChevronTop } from '@coreui/icons'
import './table.css'
import { Link } from 'react-router-dom'
import moment from 'moment'

export default function DataReportTable({ reportData, setReportData, dates }) {
  const [sortedKey, setSortedKey] = useState('')
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'asc',
  })

  const sortTable = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    const sorted = [...reportData].sort((a, b) => {
      if (a[key] < b[key]) {
        return direction === 'asc' ? -1 : 1
      }
      if (a[key] > b[key]) {
        return direction === 'asc' ? 1 : -1
      }
      return 0
    })
    setReportData(sorted)
    setSortedKey(key)
    setSortConfig({ key, direction })
  }

  const calculateContractDuration = (startDate, endDate) => {
    if (!startDate || !endDate) {
      return "-"; // Handle missing dates
    }

    const start = moment(startDate);
    const end = moment(endDate);

    if (!start.isValid() || !end.isValid()) {
      return "N/A"; // Handle invalid dates
    }

    const duration = moment.duration(end.diff(start));
    const years = duration.years();
    const months = duration.months();
    const days = duration.days();

    return `${years || 0} years, ${months || 0} months, ${days || 0} days`;
  };

  const formatDate = (date) => {
    return moment(date).isValid() ? moment(date).format('DD-MM-YYYY') : '-';
  }

  return (
    <>
      <thead className="thead-dark" style={{ backgroundColor: '#e8e9eb' }}>
        <tr>
          <th onClick={() => sortTable('id')} style={{width:'3%'}}>Sr</th>
          <th onClick={() => sortTable('id')} style={{width:'5%'}}>
            ID{' '}
            {sortedKey === 'id' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('full_name')} style={{width:'20%'}}>
            Full Name
            {sortedKey === 'full_name' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('designation')}>
            Designation
            {sortedKey === 'designation' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('department')}>
            Department
            {sortedKey === 'department' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('branch')}>
            Branch
            {sortedKey === 'branch' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('date_of_joining')}>
            Date of Joining
            {sortedKey === 'date_of_joining' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('date_of_joining')}>
            Contract Start Date
            {sortedKey === 'date_of_joining' && (
              <CIcon icon={sortConfig.direction === 'asc' ? cilChevronTop : cilChevronBottom} />
            )}
          </th>
          <th onClick={() => sortTable('expiry_date')}>
            Contract Expiration Date
          </th>
          <th onClick={() => sortTable('contract_duration')}>
            Contract Duration
          </th>
          <th onClick={() => sortTable('extensions')}>
            No. of Contract Extensions
          </th>
        </tr>
      </thead>
      <tbody>
        {reportData.map((item, index) => (
          <tr key={item.id}>
            <td>{index + 1}</td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.id}&tab=emp_attendance`}
                target="_blank"
              >
                {item.id}
              </Link>
            </td>
            <td style={{ color: 'blue' }}>
              <Link
                to={`/employee-profile?id=${item.id}&tab=emp_attendance`}
                target="_blank"
              >
                {item.full_name}
              </Link>
            </td>
            <td>{item.designation?.name}</td>
            <td>{item.department?.name}</td>
            <td>{item.branch?.name}</td>
            <td>{formatDate(item.date_of_joining)}</td>
            <td>{formatDate(item.date_of_joining)}</td>
            <td>{formatDate(item.expiry_date)}</td>
            <td>{calculateContractDuration(item.date_of_joining, item.expiry_date)}</td>
            <td>{item.extensions_count || 0}</td>
          </tr>
        ))}
      </tbody>
    </>
  )
}
